import { defineMessages } from 'react-intl';

export default defineMessages({
    financeCategory: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.financeCategory',
        defaultMessage: 'Is the vehicle owned, financed, or leased?'
    },
    conditionField: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.conditionField',
        defaultMessage: 'Was the vehicle purchased new or used?'
    },
    vehiclePurchaseMonth: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.vehiclePurchaseMonth',
        defaultMessage: 'When was the vehicle purchased?'
    },
    vehiclePurchaseYear: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.vehiclePurchaseYear',
        defaultMessage: 'What year was the vehicle purchased?'
    },
    ownedLessThan6Months: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.ownedLessThan6Months',
        defaultMessage: 'Was the vehicle purchase in the last 6 months?'
    },
    primaryUse: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.primaryUse',
        defaultMessage: 'How will this vehicle be used most of the time?'
    },
    commuting: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.commuting',
        defaultMessage: 'Commute to school or work'
    },
    pleasure: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.pleasure',
        defaultMessage: 'Pleasure'
    },
    business: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.business',
        defaultMessage: 'Business'
    },
    businessUseTooltipTitle: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.businessUseTooltipTitle',
        defaultMessage: 'What is business use?'
    },
    businessUseTooltipContent: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.businessUseTooltipContent',
        defaultMessage: 'This is using your personal vehicle for business purposes such as visiting customers, making deliveries or picking up supplies/equipment on behalf of a business. For example, a realtor using their personal vehicle to transport clients to see homes.'
    },
    annualMileage: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.annualMileage',
        defaultMessage: 'Annual Mileage'
    },
    parkedAtPrimary: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.parkedAtPrimary',
        defaultMessage: 'Is the vehicle primarily parked at the insured\'s residence?'
    },
    parkedAtPrimaryTrailer: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.parkedAtPrimaryTrailer',
        defaultMessage: 'Is the trailer primarily parked at the insured\'s residence?'
    },
    tooltipWhatDoesThisMean: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.tooltipWhatDoesThisMean',
        defaultMessage: 'What does this mean?'
    },
    parkingTooltipText: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.parkingTooltipText',
        defaultMessage: 'The vehicle is typically parked at the address listed on the policy. The vehicle can be parked in the garage, carport, on street or off street. If the vehicle is typically parked at a different address, list the address.'
    },
    parkingTooltipTextTrailer: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.parkingTooltipTextTrailer',
        defaultMessage: 'The trailer is typically parked at the address listed on the policy. The trailer can be parked in the garage, carport, on street or off street. If the trailer is typically parked at a different address, list the address.'
    },
    addressHeader: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.addressHeader',
        defaultMessage: 'Address'
    },
    parkingType: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.parkingType',
        defaultMessage: 'Where is the vehicle parked?'
    },
    repairedLabel: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.repairedLabel',
        defaultMessage: 'This vehicle has a salvage title which means it was previously determined to be a total loss. Has this vehicle been repaired?'
    },
    standardErrorMsg: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.standardErrorMsg',
        defaultMessage: 'Unable to look up vehicle information by VIN. Please enter the Make, Model and Year of this vehicle.'
    },
    unableToValidateYearErrMsg: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.unableToValidateYearErrMsg',
        defaultMessage: 'Unable to look up vehicle information by VIN. Please enter the Make, Model and Year of this vehicle.'
    },
    noVehicles: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.noVehicles',
        defaultMessage: 'No Values'
    },
    paAlternateGaragingAddress: {
        id: 'ml.quoteandbind.pa.agent.alternate.garaging.address.Alternate garaging address must be in the same state as primary address',
        defaultMessage: 'Alternate garaging address must be in the same state as primary address.'
    },
    costNewLabel: {
        id: 'ml.endorsement.pa.agent.vehicle.What is cost new',
        defaultMessage: 'What is cost new?'
    },
    costNewText: {
        id: 'ml.endorsement.pa.agent.vehicle.costNewTooltipText',
        defaultMessage: 'Cost new is the original manufacturer\'s purchase price based on the year the vehicle was made. We require you to enter the cost new in the following situations: when you do not enter a VIN when quoting; when we are unable to verify your vehicle based on the VIN entered; or when your vehicle is either brand new or a 1980 or older model.'
    },
    vendorAnnualMileage: {
        id: "ml.quoteandbind.pa.agent.editVehicle.vendorAnnualMileage",
        defaultMessage: "Vendor Annual Mileage: {value}"
    },
    fuelTypeLabel: {
        id: "ml.quoteandbind.pa.agent.editVehicle.selectFuelType",
        defaultMessage: "Fuel Type"
    },
    actualCashValueLabel: {
        id: "ml.quoteandbind.pa.agent.editVehicle.actualCashValueField",
        defaultMessage: "Actual Cash Value"
    },
    purchasePriceLabel: {
        id: "ml.quoteandbind.pa.agent.editVehicle.purchasePriceField",
        defaultMessage: "Purchase Price"
    },
    agreedValueAmountLabel: {
        id: "ml.quoteandbind.pa.agent.editVehicle.agreedValueAmount",
        defaultMessage: "Agreed Value Amount"
    },
    purchaseDateInputErrorMessage:{
        id: "ml.quoteandbind.pa.agent.editVehicle.purchaseDateInputErrorMessage",
        defaultMessage: "Date cannot be greater than 7 days from today"
    },
    storageNP: {
        id: "ml.quoteandbind.pa.agent.editVehicle.storage.np",
        defaultMessage: "Storage"
    },
    pleasureNP: {
        id: "ml.quoteandbind.pa.agent.editVehicle.pleasure.np",
        defaultMessage: "Pleasure"
    },
    businessNP: {
        id: "ml.quoteandbind.pa.agent.editVehicle.business.np",
        defaultMessage: "Business"
    },
    FarmNP: {
        id: "ml.quoteandbind.pa.agent.editVehicle.Farm.np",
        defaultMessage: "Farm"
    },
    multiFarmVehiclesError: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.multiFarmVehiclesError',
        defaultMessage: 'The {description} may not be designated as a Farm Use vehicle, as only one Farm use vehicle is allowed per policy.'
    },
     farmVehiclesWarning: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.farmVehiclesWarning',
        defaultMessage: 'A {productname} policy with the Farmer or Ranch - Liability endorsement will be required when selecting Farm as the primary use of the vehicle.'
    },
    businessUseTooltipTitleNP: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.businessUseTooltipTitle.np',
        defaultMessage: 'What is business use?'
    },
    businessUseTooltipContentNP: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.businessUseTooltipContent.np',
        defaultMessage: 'Business means that the use of the automobile is required by or involved in the usual duties of the applicant or any other person in his or her occupation, profession or business, other than going to or from his or her principal place of occupation, profession or business.'
    },
    primaryUseNP: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.primaryUse.np',
        defaultMessage: 'How will this vehicle be used most of the time?'
    },
        storageUseTooltipContentNP:{
           id: 'ml.quoteandbind.pa.agent.editVehicle.storageUseTooltipContent.np',
        defaultMessage: 'Storage means This temporarily removes liability and collision coverage from the selected auto when it won`t be used for an extended period of time.'
    },
          pleasureUseTooltipContentNP:{
           id: 'ml.quoteandbind.pa.agent.editVehicle.pleasureUseTooltipContent.np',
        defaultMessage: 'Pleasure means the use of your vehicles for personal use including driving to and from work or school.'
    },
    purchaseDateInputField :{
        id: 'ml.quoteandbind.pa.partialVehicleDetail.Date Purchased',
        defaultMessage: 'Enter the date this vehicle was purchased?'
    },
    matureDriverDiscountWarning: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.matureDriverDiscountWarning',
        defaultMessage: 'Business and Storage Use vehicles are ineligible for the Mature Driver discount. Review and update vehicle assignment as needed.'
    },
    farmUseTooltipComponent: {
        id: 'ml.quoteandbind.pa.agent.editVehicle.farmUseTooltipContent.np',
        defaultMessage: 'Farm means a vehicle used exclusively at the farm residence premises and not intended to be operated on public roads. Farm use is only available if the Primary Named Insured (PNI) or Spouse is also the PNI or Spouse on a Farmers® 5.0 homeowner’s policy that includes an optional Farm Endorsement. Farm Use is available on policies that have at least one (1) other Vehicle with required liability coverages.'
    }
});
